import { SettingItem } from '../../../../../../api/com/MetaPattern/APP/MDA/User/SettingItem';

// 用户设置项的扩展封装。
export class UserSettingItem {
  private _itemValue: string | number | string[];
  private _settingItem: SettingItem;
  private _oldItemValue: string | number | string[];
  private _appId: string; // 设置当前应用的ID,用于产品下的应用设置

  constructor(itemValue: string | number | string[], settingItem: SettingItem, appId: string) {
    this._itemValue = itemValue;
    this._settingItem = settingItem;
    this._oldItemValue = itemValue;
    this._appId = appId;
  }

  // 获取当前应用的值，没设置则为null
  get appId() {
    return this._appId;
  }

  set appId(value: string) {
    this._appId = value;
  }

  // 获取用户设置的值，没设置则为null
  get itemValue() {
    return this._itemValue;
  }

  set itemValue(value: string | number | string[]) {
    this._itemValue = value;
  }

  // 获取用户设置的原始值，没设置则为null
  get oldItemValue() {
    return this._oldItemValue;
  }

  set oldItemValue(value: string | number | string[]) {
    this._oldItemValue = value;
  }

  get settingItem() {
    return this._settingItem;
  }

  set settingItem(value: SettingItem) {
    this._settingItem = value;
  }

  // 获取最终的设置值：用户有设置则使用，否则使用默认值
  public getFinalItemValue() {
    if (this._itemValue === null) {
      return this._settingItem.defaultValue;
    }
    return this._itemValue;
  }
}
